import { OpsSeitenlokalisationDisplayNameEnum } from './ops-seitenlokalisation-display-name.enum';
import { SeitenlokalisationOption } from './seitenlokalisation-option.interface';
import { SeitenlokalisationEnum } from './seitenlokalisation.enum';

/**
 * OPS-specific seitenlokalisation options
 * Uses "paarig" instead of "beidseitig" for OPS codes
 */
export const OPS_SEITENLOKALISATION_OPTIONS: SeitenlokalisationOption[] = [
  {
    id: SeitenlokalisationEnum.Links,
    name: OpsSeitenlokalisationDisplayNameEnum.Links,
  },
  {
    id: SeitenlokalisationEnum.Beidseitig,
    name: OpsSeitenlokalisationDisplayNameEnum.Paarig,
  },
  {
    id: SeitenlokalisationEnum.Rechts,
    name: OpsSeitenlokalisationDisplayNameEnum.Rechts,
  },
  {
    id: undefined,
    name: OpsSeitenlokalisationDisplayNameEnum.KeineAuswahl,
  },
];
